import { AspectRatio } from '@/components/ui/aspect-ratio'
import { cn } from '@/lib/tailwind.utils'
import HomeV2Navbar from './HomeV2Navbar'
import { useIsMobile } from '@/hooks/use-mobile'
import HomeV2NavbarMobile from './HomeV2NavbarMobile'

interface HeroBannerProps {
  className?: string
}

const HeroBanner = ({ className }: HeroBannerProps) => {
  const isMobile = useIsMobile()

  return (
    <>
      {isMobile ? <HomeV2NavbarMobile /> : <HomeV2Navbar />}
      <div className={cn('relative w-full overflow-hidden', className)}>
        <div className="relative min-h-[180px] sm:min-h-[200px] lg:min-h-0">
          <AspectRatio ratio={1372 / 180} className="hidden lg:block">
            {/* Background image */}
            <img
              src="/home_hero.jpg"
              alt=""
              aria-hidden="true"
              className="absolute inset-0 h-full w-full object-cover object-[center_75%]"
            />

            {/* Dark overlay */}
            <div className="absolute inset-0 bg-black/40" />

            {/* Content */}
            <div className="relative flex h-full flex-col justify-center px-10 py-8 pb-6">
              <h1 className="text-4xl font-bold text-white">Haere mai</h1>
              <p className="mt-2 max-w-3xl text-sm text-white/80">
                Your platform for understanding how changing hazards and environmental conditions
                affect infrastructure and communities.
              </p>
            </div>
          </AspectRatio>

          <div className="absolute inset-0 lg:hidden">
            <img
              src="/home_hero.jpg"
              alt=""
              aria-hidden="true"
              className="absolute inset-0 h-full w-full object-cover object-[center_85%]"
            />
            <div className="absolute inset-0 bg-black/40" />
          </div>

          <div className="relative flex min-h-[180px] flex-col justify-end px-5 pb-5 pt-12 sm:min-h-[200px] sm:px-8 lg:hidden">
            <h1 className="text-2xl font-bold leading-none text-white sm:text-3xl">Haere mai</h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-white/80">
              Your platform for understanding how changing hazards and environmental conditions
              affect infrastructure and communities.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default HeroBanner
